import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import activateHideAllPricesMode from "@store/Store/Data/HideAllPricesMode/Handlers/ActivateHideAllPricesMode";
import { getHideAllPricesModeOn } from "@store/Store/Data/HideAllPricesMode/HideAllPricesModeSelector";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

type StoreHideAllPricesModeToggleProps = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: StoreApplicationState) => ({
    isHideAllPricesModeOn: getHideAllPricesModeOn(state),
});

const mapDispatchToProps = {
    activateHideAllPricesMode,
};

const StoreHideAllPricesModeToggle: React.FC<StoreHideAllPricesModeToggleProps> = ({
    isHideAllPricesModeOn,
    activateHideAllPricesMode,
}) => {

    const onActivateHideAllPricesModeHandler: CheckboxProps["onChange"] = (_, value) => {
        activateHideAllPricesMode(value);
    };

    return (
        <Checkbox
            onChange={onActivateHideAllPricesModeHandler}
            checked={isHideAllPricesModeOn}
        >
            {translate("Hide Prices")}
        </Checkbox>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreHideAllPricesModeToggle);